import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShopService } from 'src/app/services/shop.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-restaurant-content',
  templateUrl: './restaurant-content.component.html',
  styleUrls: ['./restaurant-content.component.scss']
})
export class RestaurantContentComponent implements OnInit, OnDestroy {

  menuItems = [
    {title: 'ORDER', action: 'delivery'},
    {title: 'TAKEOUT', action: 'takeout'},
    {title: 'MENU', action: 'menu'},
    {title: 'TABLE_RESERVATION', action: 'table-reservation'},
    {title: 'GALLERY', action: 'gallery'},
  ];
  selectedMenuItem = null;
  orderType$: any;
  col1$: any;

  constructor(
    private shopService: ShopService,
    private nav: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private angulartics2: Angulartics2
  ) { }

  ngOnInit() {
    this.orderType$ = this.shopService.orderType.subscribe((o) => {
      if (o === 'takeout' || o === 'delivery') {
        this.selectedMenuItem = this.menuItems.filter((m) => m.action === o)[0];
      }
    });

    this.col1$ = this.nav.col1.subscribe((c) => {
      const col1 = c;
      if (col1 === 'menu' || col1 === 'table-reservation' || col1 === 'gallery') {
        this.selectedMenuItem = this.menuItems.filter((m) => m.action === col1)[0];
      }
    });
    this.angulartics2.eventTrack.next({ action: 'selectRestaurant' });

  }

  ngOnDestroy() {
    this.orderType$.unsubscribe();
    this.col1$.unsubscribe();
  }

  onItemClick(menuItem) {
    this.selectedMenuItem = menuItem;
    const r = this.shopService.restaurant.value.restaurantId;
    const q = JSON.parse(JSON.stringify(this.nav.shopQueryParams.value));
    q.restaurantId = r;
    if (menuItem.action === 'delivery') {
      this.angulartics2.eventTrack.next({ action: 'selectDelivery' });
      this.shopService.orderType.next(menuItem.action);
      this.nav.col1.next('address');
      q.orderType = menuItem.action;
      q.col1 = 'address';
      this.nav.shopQueryParams.next(q);
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: q });
      // this.router.navigateByUrl('/shop?restaurantId=' + r + '&orderType=delivery&col1=address');
    }
    if (menuItem.action === 'takeout') {
      this.angulartics2.eventTrack.next({ action: 'selectTakeout' });
      this.shopService.orderType.next(menuItem.action);
      this.nav.col1.next('categories');
      q.orderType = menuItem.action;
      q.col1 = 'categories';
      this.nav.shopQueryParams.next(q);
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: q });
    }
    if (menuItem.action === 'menu' ) {
      this.angulartics2.eventTrack.next({ action: 'selectMenu' });
      this.nav.col1.next('menu');
      q.orderType = null;
      q.col1 = 'menu';
      this.nav.shopQueryParams.next(q);
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: q });
    }
    if (menuItem.action === 'table-reservation' ) {
      this.angulartics2.eventTrack.next({ action: 'selectTableReservation' });
      this.nav.col1.next('table-reservation');
      q.orderType = null;
      q.col1 = 'table-reservation';
      this.nav.shopQueryParams.next(q);
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: q });
    }
    if (menuItem.action === 'gallery' ) {
      this.angulartics2.eventTrack.next({ action: 'selectGallery' });
      this.nav.col1.next('gallery');
      q.orderType = null;
      q.col1 = 'gallery';
      this.nav.shopQueryParams.next(q);
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: q });
    }
  }

}
